import React, { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { getYoutubeEmbed } from "../lib/api";
import { optimizeImageUrl, HERO_PAGE_WIDTH } from "../lib/images";
import PlayerLoadingOverlay from "./PlayerLoadingOverlay";

export default function LiveStreamPlayer({ stream, autoplay = true, className = "" }) {
  const [loading, setLoading] = useState(true);
  const embed = stream?.embedUrl ? getYoutubeEmbed(stream.embedUrl, autoplay) : null;

  useEffect(() => {
    if (!embed) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 12000);
    return () => clearTimeout(timeout);
  }, [embed]);

  if (!stream) return null;

  const handleLoad = () => {
    window.setTimeout(() => setLoading(false), 400);
  };

  if (embed) {
    return (
      <div className="relative w-full h-full bg-[#0a0b16]">
        <PlayerLoadingOverlay
          loading={loading}
          label="Canlı yayın yükleniyor..."
          sublabel={stream.title ? `${stream.title} hazırlanıyor` : "Lütfen bekleyin"}
          coverImage={stream.coverImage}
        />
        <iframe
          src={embed}
          title={stream.title}
          onLoad={handleLoad}
          className={`w-full h-full transition-opacity duration-500 ${className} ${
            loading ? "opacity-0" : "opacity-100"
          }`}
          allow="autoplay; encrypted-media; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="w-full h-full relative flex flex-col items-center justify-center text-center bg-black">
      {stream.coverImage && (
        <img
          src={optimizeImageUrl(stream.coverImage, HERO_PAGE_WIDTH)}
          alt=""
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover opacity-25"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0b16] to-transparent" />
      <div className="relative z-10 flex flex-col items-center px-6">
        <div className="w-16 h-16 rounded-full bg-[rgba(139,92,246,0.18)] border border-[rgba(168,85,247,0.4)] flex items-center justify-center mb-4 float-slow">
          <CalendarClock size={32} className="text-[var(--tv-purple-bright)]" />
        </div>
        <p className="text-white font-semibold text-lg">Canlı yayın bağlantısı henüz tanımlanmadı</p>
        <p className="text-[var(--tv-muted)] text-sm mt-2 max-w-md">
          Yayın başladığında bu ekrandan canlı olarak izleyebileceksiniz.
        </p>
      </div>
    </div>
  );
}
